import { Item } from '@/helper/types';
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import axios from 'axios';

// Define the return type of the async thunk
interface GetItemsResponse {
  data: Item[];
}

export const getItemsContent = createAsyncThunk<GetItemsResponse, void>(
  'leads/getItemsContent',
  async (thunkApi) => {
    const response = await axios.get<GetItemsResponse>('/api/users?page=2');
    const data: GetItemsResponse = response.data;
    return data;
  }
);
interface ItemsState {
  isLoading: boolean;
  leads: Item[];
}

const initialState: ItemsState = {
  isLoading: false,
  leads: [],
};

const leadsSlice = createSlice({
  name: 'leads',
  initialState,
  reducers: {
    addNewItem: (state, action: PayloadAction<{ newItemObj: Item }>) => {
      // Add the new lead to the leads array
      state.leads.push(action.payload.newItemObj);
    },
    deleteItem: (state, action: PayloadAction<{ index: number }>) => {
      // Delete the lead by index
      state.leads.splice(action.payload.index, 1);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getItemsContent.pending, (state) => {
      // Set isLoading to true while fetching data
      state.isLoading = true;
    });
    builder.addCase(getItemsContent.fulfilled, (state, action) => {
      // Set isLoading to false and update leads state with the fetched data
      state.isLoading = false;
      state.leads = action.payload.data;
    });
    builder.addCase(getItemsContent.rejected, (state) => {
      // Set isLoading to false if fetching data fails
      state.isLoading = false;
    });
  },
});

export const { addNewItem, deleteItem } = leadsSlice.actions;

export default leadsSlice.reducer;
